// extracted by mini-css-extract-plugin
export default {"stack":"license-required_stack__fWUmy","card":"license-required_card__FG0ff","actions":"license-required_actions__tKw3K"};